import { faRobot } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../../core/components/Icon.tsx';
import classnames from '../../../core/utils/classnames.tsx';

const AgentsIcon = withIcon(faRobot);

type Props = {
    className?: string;
    assistant?: boolean;
};

const AgentBadge = ({ className, assistant = false }: Props) => {
    const { t } = useTranslation('integrations');
    return (
        <span
            className={classnames(
                'flex items-center gap-1 text-xs font-normal px-1.5 py-0.5 rounded flex-none',
                assistant
                    ? 'bg-surface-agent-weak text-content-agent-default'
                    : 'bg-surface-brand-weak text-content-brand-default',
                className
            )}
        >
            <AgentsIcon className="text-[10px]" />
            {t(`smartInbox.config.events.customCategories.form.${assistant ? 'assistantBadge' : 'agentBadge'}`)}
        </span>
    );
};

export default AgentBadge;
